export const InfoIncon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99998 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 9.99998 1.66667C5.39998 1.66667 1.66664 5.4 1.66664 10C1.66664 14.6 5.39998 18.3333 9.99998 18.3333ZM9.16664 5.83333L10.8333 5.83333L10.8333 7.5L9.16665 7.5L9.16664 5.83333ZM9.16665 9.16667L10.8333 9.16667L10.8333 14.1667L9.16665 14.1667L9.16665 9.16667Z" fill="#00C0F3" />
    </svg>
  )
}